import { GenericService } from 'services/genericService';
import {
	addDepartment,
	getDepartmentDetails,
	getDepartmentsForCurrentUser,
	updateDepartment,
	deleteDepartment,
	assignNumbersToDepartment,
	assignManagersToDepartment,
	deleteManagersFromDepartment,
	deleteNumbersAndUsersFromDepartment,
	getAccountManagerDetails,
} from 'utils/api/queries/omantelApi';
import { Observable } from 'rxjs';
import { Departments } from 'utils/api/models/departments/departments';
import { DepartmentDetails } from 'utils/api/models/departments/departmentDetails';
import * as payloads from 'utils/api/payloads/omantelApi';
import { AccountManagers } from 'utils/api/models/users/accountManagers';

export class DepartmentsService extends GenericService {
	public static getDepartmentsForCurrentUser(): Observable<Departments> {
		return getDepartmentsForCurrentUser()
			.withErrorHandling()
			.call();
	}

	public static addDepartment(departmentData: payloads.DepartmentData): Observable<any> {
		return addDepartment(departmentData)
			.withErrorHandling()
			.call();
	}

	public static getDepartmentDetails(departmentId: string, accountId: string): Observable<DepartmentDetails> {
		return getDepartmentDetails(departmentId, accountId)
			.withErrorHandling()
			.call();
	}

	public static updateDepartment(departmentData: payloads.DepartmentData): Observable<any> {
		return updateDepartment(departmentData)
			.withErrorHandling()
			.call();
	}

	public static deleteDepartment(departmentId: string): Observable<any> {
		return deleteDepartment(departmentId)
			.withErrorHandling()
			.call();
	}

	public static assignNumbersToDepartment(departmentNumbers: payloads.DepartmentNumbers): Observable<any> {
		return assignNumbersToDepartment(departmentNumbers)
			.withErrorHandling()
			.call();
	}

	public static assignManagersToDepartment(data: payloads.AssignManagersToDepartmentData): Observable<any> {
		return assignManagersToDepartment(data)
			.withErrorHandling()
			.call();
	}

	public static deleteManagersFromDepartment(data: payloads.DeleteManagersFromDepartmentData): Observable<any> {
		return deleteManagersFromDepartment(data)
			.withErrorHandling()
			.call();
	}

	public static deleteNumbersAndUsersFromDepartment(data: payloads.NumbersUsersToDeleteData): Observable<any> {
		return deleteNumbersAndUsersFromDepartment(data)
			.disableCache()
			.withErrorHandling()
			.call();
	}

	public static getAccountManagerDetails(
		documentId: string,
		documentType: types.organizations.documentType
	): Observable<AccountManagers> {
		return getAccountManagerDetails(documentId, documentType).call();
	}
}
